<template>
  <div class="module-detail">
    <Card shadow>
      <Row :style="{marginBottom: '10px'}">
        <div :style="{float: 'left'}">
          <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'module_manage', query: { page: $route.query.lastPage }})">返回列表</Button>
        </div>
        <div :style="{float: 'right'}">
          <Button size="small"
                  type="warning"
                  icon="ios-create-outline"
                  v-if="canEditModule"
                  @click="$router.push({name: 'module_edit', params: {id: $route.params.id}})">编辑</Button>
        </div>
      </Row>
      <Card shadow class="content workflow-module-detail-content">
        <div class="main">
          <div>
            <Row style="margin-bottom: 10px">
              <Col :xs="24" :sm="24" :md="24" :lg="15">
                <Row class="title">
                  <h4 :style="{float: 'left'}">模块详情</h4>
                </Row>
                <Alert v-if="moduleInfoError" type="warning" show-icon>获取模块详情数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>模块名</dt><dd>{{ moduleInfo.name }}</dd>
                  </dl>
                  <dl>
                    <dt>所属项目</dt><dd>{{ moduleInfo.tenant_name }}</dd>
                  </dl>
                  <dl>
                    <dt>描述</dt><dd>{{ moduleInfo.description }}</dd>
                  </dl>
                  <dl>
                    <dt>开发人员</dt>
                    <dd><Tag v-for="item in moduleInfo.developers" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>
                  </dl>
                  <dl>
                    <dt>创建用户</dt><dd v-if="moduleInfo.created_user">{{ moduleInfo.created_user.name ?
                    moduleInfo.created_user.name : moduleInfo.created_user.username }}</dd>
                  </dl>
                  <dl>
                    <dt>创建时间</dt><dd>{{ moment(moduleInfo.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl>
                    <dt>最后修改时间</dt><dd>{{ moment(moduleInfo.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <div v-if="moduleInfo.deleted">
                    <dl>
                      <dt>状态</dt><dd><span :style="{color: 'red'}">已删除</span></dd>
                    </dl>
                    <dl>
                      <dt>删除时间</dt><dd><span :style="{color: 'red'}">{{ moment(moduleInfo.deleted_at).format('YYYY-MM-DD HH:mm:ss') }}</span></dd>
                    </dl>
                  </div>
                </div>
                <div style="margin-top: 10px">
                  <Alert v-if="deploymentInfoError" type="warning" show-icon>获取模块部署信息数据失败</Alert>
                  <div v-else-if="developDeploymentInfo.have || testDeploymentInfo.have || productDeploymentInfo.have">
                    <Row class="title">
                      <h4 :style="{float: 'left'}">部署信息</h4>
                    </Row>
                    <Row style="margin-bottom: 10px" v-if="developDeploymentInfo.have" class="develop-deployment-info">
                      <Alert show-icon>
                        <b>开发环境</b>
                        <Icon type="ios-bulb-outline" slot="icon"></Icon>
                        <Row style="padding-top: 20px">
                          <div class="info-property-none-border">
                            <dl>
                              <dt>部署服务器</dt>
                              <dd><Tag v-for="serverItem in developDeploymentInfo.server" :key="'develop_server_' + serverItem.id" color="primary">{{ serverItem.hostname }}</Tag></dd>
                            </dl>
                            <dl>
                              <dt>Jenkins Job</dt><dd>{{ developDeploymentInfo.jenkins_job }}</dd>
                            </dl>
                            <dl>
                              <dt>部署地址</dt><dd>{{ developDeploymentInfo.address_in }}</dd>
                            </dl>
                            <dl>
                              <dt>部署外网地址</dt><dd>{{ developDeploymentInfo.address_ex }}</dd>
                            </dl>
                            <!--<dl>-->
                            <!--<dt>代码发布变更审批流程</dt>-->
                            <!--<dd>-->
                            <!--<span style="margin-right: 30px"><b>流程名称：</b>{{ developDeploymentInfo.code_release_process.name }} </span>-->
                            <!--<span><b>是否有序：</b>{{ developDeploymentInfo.code_release_process.ordered ? '是' : '否' }} </span>-->
                            <!--<ApprovalSteps :process="developDeploymentInfo.code_release_process"></ApprovalSteps>-->
                            <!--</dd>-->
                            <!--</dl>-->
                            <!--<dl>-->
                            <!--<dt>数据库变更审批流程</dt>-->
                            <!--<dd>-->
                            <!--<span style="margin-right: 30px"><b>流程名称：</b>{{ developDeploymentInfo.db_release_process.name }} </span>-->
                            <!--<span><b>是否有序：</b>{{ developDeploymentInfo.db_release_process.ordered ? '是' : '否' }} </span>-->
                            <!--<ApprovalSteps :process="developDeploymentInfo.db_release_process"></ApprovalSteps>-->
                            <!--</dd>-->
                            <!--</dl>-->
                          </div>
                        </Row>
                      </Alert>
                    </Row>
                    <Row style="margin-bottom: 10px" v-if="testDeploymentInfo.have" class="test-deployment-info">
                      <Alert show-icon type="warning">
                        <b>测试环境</b>
                        <Icon type="ios-bulb-outline" slot="icon"></Icon>
                        <Row style="padding-top: 20px">
                          <div class="info-property-none-border">
                            <dl>
                              <dt>部署服务器</dt>
                              <dd><Tag v-for="serverItem in testDeploymentInfo.server" :key="'test_server_' + serverItem.id" color="primary">{{ serverItem.hostname }}</Tag></dd>
                            </dl>
                            <dl>
                              <dt>Jenkins Job</dt><dd>{{ testDeploymentInfo.jenkins_job }}</dd>
                            </dl>
                            <dl>
                              <dt>部署地址</dt><dd>{{ testDeploymentInfo.address_in }}</dd>
                            </dl>
                            <dl>
                              <dt>部署外网地址</dt><dd>{{ testDeploymentInfo.address_ex }}</dd>
                            </dl>
                            <!--<dl>-->
                            <!--<dt>代码发布变更审批流程</dt>-->
                            <!--<dd>-->
                            <!--<span style="margin-right: 30px"><b>流程名称：</b>{{ testDeploymentInfo.code_release_process.name }} </span>-->
                            <!--<span><b>是否有序：</b>{{ testDeploymentInfo.code_release_process.ordered ? '是' : '否' }} </span>-->
                            <!--<ApprovalSteps :process="testDeploymentInfo.code_release_process"></ApprovalSteps>-->
                            <!--</dd>-->
                            <!--</dl>-->
                            <!--<dl>-->
                            <!--<dt>数据库变更审批流程</dt>-->
                            <!--<dd>-->
                            <!--<span style="margin-right: 30px"><b>流程名称：</b>{{ testDeploymentInfo.db_release_process.name }} </span>-->
                            <!--<span><b>是否有序：</b>{{ testDeploymentInfo.db_release_process.ordered ? '是' : '否' }} </span>-->
                            <!--<ApprovalSteps :process="testDeploymentInfo.db_release_process"></ApprovalSteps>-->
                            <!--</dd>-->
                            <!--</dl>-->
                          </div>
                        </Row>
                      </Alert>
                    </Row>
                    <Row v-if="productDeploymentInfo.have" class="product-deployment-info">
                      <Alert show-icon type="error">
                        <b>生产环境</b>
                        <Icon type="ios-bulb-outline" slot="icon"></Icon>
                        <Row style="padding-top: 20px">
                          <div class="info-property-none-border">
                            <dl>
                              <dt>部署服务器</dt>
                              <dd><Tag v-for="serverItem in productDeploymentInfo.server" :key="'product_server_' + serverItem.id" color="primary">{{ serverItem.hostname }}</Tag></dd>
                            </dl>
                            <dl>
                              <dt>Jenkins Job</dt><dd>{{ productDeploymentInfo.jenkins_job }}</dd>
                            </dl>
                            <dl>
                              <dt>部署地址</dt><dd>{{ productDeploymentInfo.address_in }}</dd>
                            </dl>
                            <dl>
                              <dt>部署外网地址</dt><dd>{{ productDeploymentInfo.address_ex }}</dd>
                            </dl>
                            <!--<dl>-->
                            <!--<dt>代码发布变更审批流程</dt>-->
                            <!--<dd>-->
                            <!--<span style="margin-right: 30px"><b>流程名称：</b>{{ productDeploymentInfo.code_release_process.name }} </span>-->
                            <!--<span><b>是否有序：</b>{{ productDeploymentInfo.code_release_process.ordered ? '是' : '否' }} </span>-->
                            <!--<ApprovalSteps :process="productDeploymentInfo.code_release_process"></ApprovalSteps>-->
                            <!--</dd>-->
                            <!--</dl>-->
                            <!--<dl>-->
                            <!--<dt>数据库变更审批流程</dt>-->
                            <!--<dd>-->
                            <!--<span style="margin-right: 30px"><b>流程名称：</b>{{ productDeploymentInfo.db_release_process.name }} </span>-->
                            <!--<span><b>是否有序：</b>{{ productDeploymentInfo.db_release_process.ordered ? '是' : '否' }} </span>-->
                            <!--<ApprovalSteps :process="productDeploymentInfo.db_release_process"></ApprovalSteps>-->
                            <!--</dd>-->
                            <!--</dl>-->
                          </div>
                        </Row>
                      </Alert>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col span="24" :md="{ span: 6, offset: 1 }">
                <div>
                  <div class="title" >
                    <h4>日志信息</h4>
                  </div>
                  <FlowLogs :logs = "moduleInfo.revision_logs" />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Card>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { detailModule, getModuleDevelopments } from '@/api/workflow/project'
import { getTenantRoles } from '@/api/workflow/tenant'
import ApprovalSteps from '../components/approval-steps'
import FlowLogs from '../components/Logs'

export default {
  components: {
    FlowLogs,
    ApprovalSteps
  },
  data () {
    return {
      moduleInfo: {},
      developDeploymentInfo: {},
      testDeploymentInfo: {},
      productDeploymentInfo: {},
      moment: moment,
      moduleInfoError: false,
      deploymentInfoError: false,
      canEditModule: false
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    },
    '$store.state.user.defaultTenant' () {
      this.getTenantRolesData()
    }
  },
  methods: {
    // 初始化
    init () {
      this.getModuleData()
      this.getModuleDevelopmentInfo()
      this.getTenantRolesData()
    },
    // 获取模块信息
    getModuleData () {
      detailModule(this.$route.params.id).then(res => {
        this.moduleInfo = res.data
        this.moduleInfoError = false
      }).catch(res => {
        this.moduleInfoError = true
        console.log(res.response)
      })
    },
    // 获取模块的所有部署环境信息
    getModuleDevelopmentInfo () {
      getModuleDevelopments(this.$route.params.id).then(res => {
        if (res.data.develop) {
          this.developDeploymentInfo = res.data.develop
          this.developDeploymentInfo.have = true
        }
        if (res.data.test) {
          this.testDeploymentInfo = res.data.test
          this.testDeploymentInfo.have = true
        }
        if (res.data.product) {
          this.productDeploymentInfo = res.data.product
          this.productDeploymentInfo.have = true
        }
        this.deploymentInfoError = false
      }).catch(res => {
        this.deploymentInfoError = true
        console.log(res.response)
      })
    },

    // 获取租户角色信息
    getTenantRolesData () {
      if (this.$store.state.user.superuser) {
        this.canEditModule = true
      } else {
        getTenantRoles(this.$store.state.user.defaultTenant).then(res => {
          console.log(res.data)
          if (res.data) {
            this.canEditModule = res.data.can_edit_module
          } else {
            this.canEditModule = false
          }
        }).catch(res => {
          console.log(res.response)
        })
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .workflow-module-detail-content {
    .develop-deployment-info {
      .ivu-steps {
        .ivu-steps-head {
          background: #F0FAFF;
        }
        .ivu-steps-title {
          background: #F0FAFF;
        }
      }
    }
    .test-deployment-info {
      .ivu-steps {
        .ivu-steps-head {
          background: #FFF9E6;
        }
        .ivu-steps-title {
          background: #FFF9E6;
        }
      }
    }
    .product-deployment-info {
      .ivu-steps {
        .ivu-steps-head {
          background: #FFEFE6;
        }
        .ivu-steps-title {
          background: #FFEFE6;
        }
      }
    }
  }
  @media screen and (max-width:768px){
    .module-detail .content .main .info-property-none-border dl dt{
      width:120px;
    }
  }
</style>
